import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const invalidateTutorial = (user, tutorial) => {
  return requestWithPromise(
    `/api/tutorials/${getIdOrNull(tutorial)}/invalidate`,
    HttpMethods.POST,
    {},
    user,
    true
  )
}

export const getTutorialSteps = (user, tutorial) => {
  return requestWithPromise(
    `/api/tutorials/${getIdOrNull(tutorial)}/steps`,
    HttpMethods.GET,
    null,
    user,
    true
  )
}

export const validateTutorial = (user, tutorial) => {
  return requestWithPromise(
    `/api/tutorials/${getIdOrNull(tutorial)}/validate`,
    HttpMethods.POST,
    {},
    user,
    true
  )
}
